import React, { useCallback, useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface CarouselProps {
  images: {
    src: string;
    alt: string;
  }[];
  autoPlay?: boolean;
  interval?: number;
}
export const Carousel = ({
  images,
  autoPlay = true,
  interval = 5000
}: CarouselProps) => {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const paginate = useCallback((newDirection: number) => {
    setDirection(newDirection);
    setIndex(prev => (prev + newDirection + images.length) % images.length);
  }, [images.length]);
  useEffect(() => {
    if (!autoPlay) return;
    const t = setInterval(() => paginate(1), interval);
    return () => clearInterval(t);
  }, [autoPlay, interval, paginate]);
  return <div className="relative w-full" data-id="element-1">
      <div className="relative aspect-[4/3] sm:aspect-[16/10] md:aspect-[16/9] overflow-hidden rounded-sm bg-stone/5" data-id="element-2">
        <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-3">
          <motion.img key={index} src={images[index].src} alt={images[index].alt} custom={direction} initial={{
          opacity: 0,
          scale: 1.03
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 1
        }} transition={{
          duration: 1.2,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} className="absolute inset-0 w-full h-full object-cover" loading="lazy" data-id="element-4" />
        </AnimatePresence>

        {/* Arrows */}
        <button onClick={() => paginate(-1)} aria-label="Imagen anterior" className="absolute left-2 sm:left-6 top-1/2 -translate-y-1/2 w-9 h-9 sm:w-12 sm:h-12 rounded-full bg-cream/80 hover:bg-cream text-stone flex items-center justify-center backdrop-blur-sm transition-colors" data-id="element-5">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-6">
            <path d="m15 18-6-6 6-6" data-id="element-7" />
          </svg>
        </button>
        <button onClick={() => paginate(1)} aria-label="Siguiente imagen" className="absolute right-2 sm:right-6 top-1/2 -translate-y-1/2 w-9 h-9 sm:w-12 sm:h-12 rounded-full bg-cream/80 hover:bg-cream text-stone flex items-center justify-center backdrop-blur-sm transition-colors" data-id="element-8">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-9">
            <path d="m9 18 6-6-6-6" data-id="element-10" />
          </svg>
        </button>
      </div>

      {/* Dots */}
      <div className="flex justify-center gap-2 mt-6" data-id="element-11">
        {images.map((_, i) => <button key={i} onClick={() => {
        setDirection(i > index ? 1 : -1);
        setIndex(i);
      }} aria-label={`Ir a imagen ${i + 1}`} className={`h-[2px] transition-all duration-500 ${i === index ? 'w-10 bg-stone' : 'w-5 bg-stone/30'}`} data-id="element-12" />)}
      </div>
    </div>;
};